import { savingsGuaranteeHash } from '@/dataroom/ui/components/Landing/Legacy/Sections/Faq/faqCollection';

/**
 * This temporary hardcode needs for displaying country flags in select.
 * It could be deleted if backend returns countryCode.
 */
export const currencyCodes = {
  AUD: 'AU',
  CAD: 'CA',
  CNY: 'CN',
  EUR: 'EU',
  GBP: 'GB',
  JPY: 'JP',
  USD: 'US',
};

// Used in finsight ourSolutions page
export const savingsGuaranteeFootnoteUrl = `/pricing#${ savingsGuaranteeHash }`;
